<header class="top-navigation">
  <div class="top-navigation__inner">
    <div class="top-navigation__left">
      <button
        class="top-navigation__icon-button top-navigation__mobile-toggle"
        type="button"
        [attr.aria-expanded]="mobileMenuOpen()"
        aria-controls="primary-mobile-navigation"
        pTooltip="Open navigation"
        tooltipPosition="bottom"
        (click)="toggleMobileMenu()"
      >
        <i class="pi pi-bars" aria-hidden="true"></i>
      </button>

      <a class="top-navigation__brand" routerLink="/dashboard" [attr.aria-label]="appName" (click)="closeMobileMenu()">
        <span class="top-navigation__brand-mark">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <polygon points="12,1.8 21.5,7 18,18 12,22 6,18 2.5,7" />
            <line x1="12" y1="1.8" x2="8" y2="8.2" />
            <line x1="12" y1="1.8" x2="16" y2="8.2" />
            <line x1="2.5" y1="7" x2="8" y2="8.2" />
            <line x1="21.5" y1="7" x2="16" y2="8.2" />
            <line x1="6" y1="18" x2="8" y2="8.2" />
            <line x1="18" y1="18" x2="16" y2="8.2" />
            <line x1="6" y1="18" x2="12" y2="14.8" />
            <line x1="18" y1="18" x2="12" y2="14.8" />
            <path d="M6.2 12 Q12 6.8 17.8 12 Q12 17.2 6.2 12Z" />
            <circle cx="12" cy="12" r="2.5" />
            <circle cx="12" cy="12" r="1" />
            <circle cx="12.7" cy="11.3" r="0.35" />
          </svg>
        </span>
        <span class="top-navigation__brand-text">{{ appName }}</span>
      </a>

      <nav class="top-navigation__nav" aria-label="Primary navigation">
        @for (item of navigationItems; track item.route) {
          <span
            class="top-navigation__nav-item"
            routerLinkActive="top-navigation__nav-item--active"
            [routerLinkActiveOptions]="{ exact: item.exact === true }"
          >
            <a class="top-navigation__link" [routerLink]="item.route">
              <i class="top-navigation__link-icon" [class]="item.icon" aria-hidden="true"></i>
              <span>{{ item.label }}</span>
            </a>
            @if (item.activeRoute) {
              <a
                class="top-navigation__active-route"
                [routerLink]="item.activeRoute"
                aria-hidden="true"
                tabindex="-1"
              ></a>
            }
          </span>
        }
      </nav>
    </div>

    <div class="top-navigation__actions">
      <button
        class="top-navigation__icon-button"
        type="button"
        [attr.aria-label]="layoutState.darkMode() ? 'Use light theme' : 'Use dark theme'"
        [pTooltip]="layoutState.darkMode() ? 'Use light theme' : 'Use dark theme'"
        tooltipPosition="bottom"
        (click)="layoutState.toggleDarkMode()"
      >
        <i [class]="layoutState.darkMode() ? 'pi pi-sun' : 'pi pi-moon'" aria-hidden="true"></i>
      </button>

      <p-menu #userMenu [model]="userMenuItems" [popup]="true" />
      <button class="top-navigation__profile" type="button" (click)="userMenu.toggle($event)">
        <span class="top-navigation__avatar">{{ userInitial }}</span>
        <span class="top-navigation__profile-copy">
          <span class="top-navigation__profile-name">{{ userLabel }}</span>
          <span class="top-navigation__profile-role">{{ userRole }}</span>
        </span>
        <i class="pi pi-chevron-down top-navigation__profile-icon" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  @if (mobileMenuOpen()) {
    <nav id="primary-mobile-navigation" class="top-navigation__mobile-nav" aria-label="Primary navigation">
      @for (item of navigationItems; track item.route) {
        <span
          class="top-navigation__mobile-item"
          routerLinkActive="top-navigation__mobile-item--active"
          [routerLinkActiveOptions]="{ exact: item.exact === true }"
        >
          <a class="top-navigation__mobile-link" [routerLink]="item.route" (click)="closeMobileMenu()">
            <i class="top-navigation__link-icon" [class]="item.icon" aria-hidden="true"></i>
            <span>{{ item.label }}</span>
          </a>
          @if (item.activeRoute) {
            <a
              class="top-navigation__active-route"
              [routerLink]="item.activeRoute"
              aria-hidden="true"
              tabindex="-1"
            ></a>
          }
        </span>
      }
    </nav>
  }
</header>
